import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Typography } from '@one-thd/sui-atomic-components';
import { stairs } from '../../selectors/stairs';
import { roomMeasureSelector } from '../../selectors/roomMeasure';
import {
  totalCarpetPrice,
  totalCarpetPadPrice,
  totalProjectPrice,
  totalRegionalInstallPrice,
  installationThresholdMetSelector,
  estimateErrorMsgSelector,
  selectSelectedCarpetChoice,
  getRegionalCarpetInstallPrice,
  regionalSelectionsChoiceSelector,
} from '../../selectors/pricing/index';
import { selectedCarpetPad } from '../../selectors/carpetPad';
import { integerPart, decimalPart, currencyStringFormat } from '../../utils/format';
import { updateRoomPrice, updatePadPrice } from '../../actions';
import { updateStepPrice, updateStepPadPrice } from '../../actions/stepsAction';
import { regionalPrice } from '../../actions/regionalInstallActions';
import { TotalPriceText } from './styles';

function SummaryLineItems({ isSkeleton }) {
  if (isSkeleton) {
    return (
      <>
        <hr className="divider" />
        <div className="summary-quote">
          <div className="price-items">
            <div className="price-item" style={{ order: 1 }}>
              <Typography variant="h4" style={{ fontWeight: 'bold' }}>Total Cost Estimate:</Typography>
              <Typography variant="h4" style={{ paddingRight: '1rem', fontWeight: 'bold' }}>--</Typography>
            </div>
            <div className="price-item" style={{ order: 2 }}>
              <Typography paragraph>(Calculated after selecting a carpet and entering room/stair information)</Typography>
            </div>
          </div>
        </div>
      </>
    );
  }

  const dispatch = useDispatch();
  const { measure } = useSelector(roomMeasureSelector);
  const hasFreeInstallation = useSelector(installationThresholdMetSelector);
  const hasRegionalInstallPrice = useSelector(getRegionalCarpetInstallPrice);
  const regionalInstallChoice = useSelector(regionalSelectionsChoiceSelector);
  const regionalInstallPrice = useSelector(totalRegionalInstallPrice);
  const stairsInfos = useSelector(stairs);
  const carpetPrice = useSelector(totalCarpetPrice);
  const selectedChoice = useSelector(selectSelectedCarpetChoice);
  const selectedPad = useSelector(selectedCarpetPad);
  const totalPadPrice = useSelector(totalCarpetPadPrice);
  const total = useSelector(totalProjectPrice);
  const estimateErrorMsg = useSelector(estimateErrorMsgSelector);

  useEffect(() => {
    if (selectedChoice) {
      const padPrice = selectedPad?.padPrice || 0;
      dispatch(updateRoomPrice(selectedChoice.priceSquareYard));
      dispatch(updateStepPrice(selectedChoice.priceSquareYard));
      dispatch(updatePadPrice(padPrice));
      dispatch(updateStepPadPrice(padPrice));
    }
    if (regionalInstallPrice) {
      dispatch(regionalPrice(regionalInstallPrice, regionalInstallChoice));
    }
  }, [carpetPrice, selectedPad, regionalInstallPrice]);

  const hasSelectedCarpet = measure.some((el) => el.squarePrice > 0) || stairsInfos.totalPrice > 0;
  const showEmptyPrice = measure.every((el) => el.price <= 0) && ((stairsInfos?.totalPrice || 0) <= 0);

  return (
    <>
      <hr className="divider" />
      <div className="summary-quote">
        <div className="price-items">
          <div className="price-item" style={{ order: 1 }}>
            <Typography variant="h4" style={{ fontWeight: 'bold' }}>Total Cost Estimate:</Typography>
            {showEmptyPrice ?
              (
                <Typography variant="h4" style={{ paddingRight: '1rem', fontWeight: 'bold' }}>--</Typography>
              ) : (
                <TotalPriceText>
                  <span className="tcc">&#36;</span>
                  <span>{integerPart(total)}</span>
                  <span className="tcc">{decimalPart(total)}</span>
                </TotalPriceText>
              )}
          </div>
          {hasSelectedCarpet ?
            (
              <>
                <div className="price-item" style={{ order: 3 }}>
                  <Typography paragraph>Carpet</Typography>
                  <Typography paragaraph>${currencyStringFormat(carpetPrice)}</Typography>
                </div>
                <div className="price-item" style={{ order: 4 }}>
                  <Typography paragraph>Carpet Padding</Typography>
                  <Typography paragraph>${currencyStringFormat(totalPadPrice)}</Typography>
                </div>
                <div className="price-item" style={{ order: hasFreeInstallation ? 2 : 5 }}>
                  <Typography paragraph>Basic Installation</Typography>
                  {!hasRegionalInstallPrice && (
                    hasFreeInstallation
                      ? <Typography paragraph weight="bold" style={{ color: 'green' }}>INCLUDED*</Typography>
                      : <Typography paragraph>(determined later)</Typography>
                  )}
                  {hasRegionalInstallPrice && <Typography paragraph>${currencyStringFormat(regionalInstallPrice)}</Typography>}
                </div>
              </>
            ) : (
              <div className="price-item" style={{ order: 2 }}>
                <Typography paragraph>{estimateErrorMsg}</Typography>
              </div>
            )}
        </div>

      </div>
    </>
  );
}

export default SummaryLineItems;
